import React, { useState, useEffect } from 'react';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import cypressTags from '../../support/cypressTags';
import { loadProfiles } from '../../support/items/profiles';

// TODO use this? Or just Input
import { CompanyInput } from '@united-talent-agency/julius-frontend-components';

const ProfileFilter = props => {

  const [state, setState] = useState({
    filterTypes: null,
    results: [],
    value: '',
  });

  useEffect(() => {
    performSearch(state.value);
  }, []);

  useEffect(() => {
    const { types } = props.filterModel;
    if (state.filterTypes !== types) {
      setState({ ...state, filterTypes: types });
      performSearch(state.value);
    }
  }, [props.filterModel]);

  useEffect(() => {
    if(
      props.onProfileToggle &&
      (props.filterModel?.profiles?.include?.length || 0) <= 1 || (props.filterModel?.profiles?.exclude?.length || 0) > 0 || !featureFlags.projectProfileSwitch) {
      props.onProfileToggle('OR');
    }
  }, [JSON.stringify(props.filterModel?.profiles?.include), JSON.stringify(props.filterModel?.profiles?.exclude), JSON.stringify(props.featureFlags)]);

  const performSearch = value => {
    const { filterModel } = props;
    const results = loadProfiles(filterModel.types, value);
    setState({ ...state, value, results });
  };

  const { label, onSelectProfile, filterModel, onProfileToggle, onFocusChanged = () => { }, switchChecked = true, featureFlags = {} } = props;
  const { results, value } = state;
  const selectedProfiles = filterModel && filterModel.profiles && filterModel.profiles.include;

  return (
    <div className="m-0 p-0 col w-100">
      <div
        data-cy={cypressTags.PROJECT_FILTERS.PROJECT_PROFILES_DROPDOWN}
      >
        <CompanyInput
          value={value}
          title={label}
          results={results}
          selectedResults={selectedProfiles}
          onChange={value => {
            performSearch(value);
          }}
          onSelect={profile => {
            onSelectProfile(profile);
            performSearch('');
          }}
          onFocusChanged={onFocusChanged}
          dropDownMode="inline"
        />
      </div>

      {(featureFlags.projectProfileSwitch && (filterModel?.profiles?.include?.length || 0) > 1 && (filterModel?.profiles?.exclude?.length || 0) < 1) &&
        <div className='d-flex flex-row align-items-center' style={{ paddingLeft: '10px' }}>
          <Typography>And</Typography>
          <Switch
            data-cy={cypressTags.PROJECT_FILTERS.PROJECT_PROFILES_SWITCH}
            color="default"
            checked={switchChecked}
            inputProps={{ 'aria-label': 'checkbox with default color' }}
            onChange={e => onProfileToggle(e.target.checked ? 'OR' : 'AND')}
          />
          <Typography>Or</Typography>
        </div>
      }
    </div>
  );
};

export default ProfileFilter;
